$(window).ready(function () {
    if(parseInt(omCookieUtility.getCookie('gmap-load')) === 1){
        $('.embed-responsive.blocked').each(function () {
            $(this).removeClass('blocked');
            var iframe = $(this).find('iframe').first();
            var url = iframe.data('src');
            iframe.attr('src', url);
        });
    }
    if(parseInt(omCookieUtility.getCookie('yt-load')) === 1){
        $('.ce-video.blocked').each(function () {
            $(this).removeClass('blocked');
            var iframe = $(this).find('iframe').first();
            var url = iframe.data('src');
            iframe.attr('src', url);
            var withdrawText = iframe.data('withdraw');
            //create withdraw text
            withdrawText = $('<div/>').html(withdrawText);
            $(this).append(withdrawText);
        });
    }else{
        $('.ce-video.blocked').each(function (){
            var iframe = $(this).find('iframe').first();
            var mediaContainer = $(this).find('.media__container').first();
            var btnSimple = iframe.data('button');
            var btnPerma = iframe.data('buttonperma');
            var blockText = iframe.data('blocktext');
            mediaContainer.append($('<div/>').addClass('overlay'));
            //block text
            var blockdiv = $('<div/>').addClass('blocker');
            blockdiv.append($('<div/>').addClass('text').html(blockText))
            blockdiv.append($('<button/>').data('show-content','simple').text(btnSimple))
            blockdiv.append($('<button/>').data('show-content','perma').text(btnPerma))
            mediaContainer.append(blockdiv);

        });
    }
});

$('body').on('click','.content-block button',function () {

    var iframeWrap = $(this).closest('.blocked');
    iframeWrap.removeClass('blocked');
    var iframe = iframeWrap.find('iframe').first();
    var url = iframe.data('src');
    iframe.attr('src', url);

    if($(this).data('show-content') === 2){
      //permanent
        omCookieUtility.setCookie('gmap-load',1,30);
    }
});

$('body').on('click','.ce-video .blocker button',function () {

    var iframeWrap = $(this).closest('.blocked');
    iframeWrap.removeClass('blocked');
    var iframe = iframeWrap.find('iframe').first();
    var url = iframe.data('src');
    iframe.attr('src', url);

    //create withdraw text
    var withdrawText = iframe.data('withdraw');
    withdrawText = $('<div/>').html(withdrawText);
    $(this).closest('.media__container').append(withdrawText);

    if($(this).data('show-content') === 'perma'){
        //permanent
        omCookieUtility.setCookie('yt-load',1,30);
    }
});

$('body').on('click','a[data-perma-disable="1"]',function (e) {
    e.preventDefault();
    omCookieUtility.deleteCookie('gmap-load');
    window.alert("Google Maps wurde deaktiviert. Wenn die Seite erneut aufgerufen wird, wird die Karte wieder blockiert sein");
});

$('body').on('click','a.block-withdraw',function (e) {
    e.preventDefault();
    omCookieUtility.deleteCookie('yt-load');
    window.alert("YouTube wurde deaktiviert. Wenn die Seite erneut aufgerufen wird, wird Youtube wieder blockiert sein");
});

var omCookieUtility = {
    getCookie: function(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    },
    setCookie: function(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString() + ";SameSite=Lax";
    },
    deleteCookie: function(name){ omCookieUtility.setCookie(name, '', -1); }
};